import React from 'react'
import { l } from '@manychat/manyui'

export const WaCoexistenceContactImportFinishedNotification = () => {
  return <span>{l.translate('100% contacts imported from WhatsApp Business App')}</span>
}
